import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import { FileAnswer } from "@teamprevent/common/questionnaires/model";

import { actionTaskSuccess } from "../crud/ohCase/actions";
import { FollowUpTaskModel } from "../immunisationReview/model";

import { EppDecision, Covid19VaccinationStatus } from "../immunisations/model";

import { MARK_OH_CASE_IMMUNISATION_CLEAR, MARK_OH_CASE_IMMUNISATION_CLEAR_SUCCESS, ADD_BLOOD_TEST_RESULT } from "./actionTypes";
import { immunisationOhCaseApi } from "./immunisationOhCaseApi";

export type ImmunisationCaseAction = ({ type: typeof MARK_OH_CASE_IMMUNISATION_CLEAR_SUCCESS } & Payload<{ ohCaseId: string }>);

export const markOhCaseImmunisationClearSuccess = (payload: { ohCaseId: string }) => ({
    payload,
    type: MARK_OH_CASE_IMMUNISATION_CLEAR_SUCCESS
});

export const markOhCaseImmunisationClear = (
    customerId: string,
    employeeId: string,
    ohCaseId: string,
    eppDecision: EppDecision,
    internalNotes: string,
    notes: string,
    covid19VaccinationStatus: Covid19VaccinationStatus,
    bookedDateOfFirstVaccination: moment.Moment,
    dateOfFirstVaccination: moment.Moment,
    dateOfSecondVaccination: moment.Moment) => {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(
            dispatch,
            MARK_OH_CASE_IMMUNISATION_CLEAR,
            immunisationOhCaseApi.clear(
                customerId,
                employeeId,
                ohCaseId,
                eppDecision,
                internalNotes,
                notes,
                covid19VaccinationStatus,
                bookedDateOfFirstVaccination,
                dateOfFirstVaccination,
                dateOfSecondVaccination));
        dispatch(markOhCaseImmunisationClearSuccess({ ohCaseId }));
    };
};

export const addBloodTestOutcome =
    (customerId: string, employeeId: string, ohCaseId: string, taskId: string, outcome: string, details: string, followUpTasks: FollowUpTaskModel[]) => {
        return async (dispatch: Dispatch) => {
            const tasks = await loadAndTrack(
                dispatch,
                ADD_BLOOD_TEST_RESULT,
                immunisationOhCaseApi.addBloodTestOutcome(customerId, employeeId, ohCaseId, taskId, outcome, details, followUpTasks));
            dispatch(actionTaskSuccess({ ohCaseId, tasks }));
        };
    };

export const addBloodTestResult =
    (customerId: string, employeeId: string, ohCaseId: string, taskId: string, result: string, evidence: FileAnswer) => {
        return async (dispatch: Dispatch) => {
            const tasks = await loadAndTrack(
                dispatch,
                ADD_BLOOD_TEST_RESULT,
                immunisationOhCaseApi.addBloodTestResult(customerId, employeeId, ohCaseId, taskId, result, evidence));
            dispatch(actionTaskSuccess({ ohCaseId, tasks }));
        };
    };
